import store from 'store';

const USER_KEY = 'user_key';

const util = {
  // 保存
  saveUser(user) {
    store.set(USER_KEY, JSON.parse(user));
  },
  // 读取
  getUser() {
    return store.get(USER_KEY) || {};
  },
  // 删除
  deleteUser() {
    return store.remove(USER_KEY) || {};
  },
};
export default util;
